module.exports = __webpack_public_path__ + "static/img/message.cffd726b.svg";